<template>
  <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search fcl-search-bar">
    <div v-show="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          class="el-icon-arrow-left"
          :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div v-show="showSimple && !isShowingMoreSearchCondition" class="cargo-advance-search-quick">
        <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
        <!--@clear="simSearch"-->
        <el-input
          v-if="showPriceNo"
          ref="keyword"
          v-model="filter.priceNo"
          no="priceNo"
          style="width:200px;"
          :placeholder="simQueryPlaceholder"
          :spellcheck="false"
          @blur="keyWordBlur"
          @keyup.enter.native.prevent="toQuery"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && showPriceNo"
          no="currency"
          style="width: 115px;display: inline-block;"
          filterable
          :disabled="disabled"
          :clearable="false"
          :select-type="selectTypeNames.basic_data_Currency"
          :default-value="filter.currency"
          @parentCallBack="changeCurrency"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPol"
          no="simPol"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.simPol"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPol=p.value}"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPod"
          no="simPod"
          filterable
          :placeholder="$t('Pricing.PODPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.simPod"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPod=p.value}"
        />
        <el-select
          v-if="!isShowingMoreSearchCondition && showLevel"
          v-model="filter.level"
          no="level"
          style="width:90px;display: inline-block;margin-left: 10px;"
          @change="onLevelChanged"
        >
          <el-option
            v-for="(item,index) in tiers"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div ref="searchOperations" class="cargo-advance-search-operations">
        <el-button no="query" style="margin-left: 10px" type="primary" :disabled="disabled" @click="toQuery">
          {{ $t('CargoMsg.Cargo_Query') }}
        </el-button>
        <el-button no="reset" type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </div>
    </div>
    <slot name="searchAreaHeader">
      <!--搜索条件区域-头-->
    </slot>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="section cargo-advance-search-more"
    >
      <div class="cargo-advance-search-more-operations" />
      <el-form
        ref="hbDetail"
        label-position="left"
        class="cargo-advance-search-form"
        style="min-width: 830px;margin-right: 10px"
        :inline="true"
      >
        <el-radio-group v-model="rdoGroupOrg" no="rdoGroupOrg">
          <el-radio no="POL" label="pol">{{ $t('Pricing.POL') }}</el-radio>
          <el-radio no="POLs" label="pols">{{ $t('Pricing.POLs') }}</el-radio>
          <el-radio no="COL" label="col">{{ $t('Pricing.COL') }}</el-radio>
          <el-radio no="ROL" label="rol">{{ $t('Pricing.ROL') }}</el-radio>
          <el-radio no="POLCity" label="polCityCode">{{ $t('Pricing.POLCity') }}</el-radio>
        </el-radio-group>
        <cargo-pop-select-input
          v-if="rdoGroupOrg === 'pols'"
          v-model="filter.pols"
          no="pols"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :column-defs="popSelectInputCols"
          :use-type="2"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'pol'"
          no="pol"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          style="width:190px;display: inline-block;"
          :default-value="filter.pol"
          @parentCallBack="p=>{filter.pol=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'col'"
          no="col"
          filterable
          :placeholder="$t('Pricing.COLPrompt')"
          :select-type="selectTypeNames.basic_data_Country"
          style="width:190px;display: inline-block;"
          @parentCallBack="p=>{filter.col=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'rol'"
          no="rol"
          filterable
          :select-type="selectTypeNames.basic_data_Region"
          :default-value="filter.rol"
          style="width:190px;display: inline-block;"
          @parentCallBack="p=>{filter.rol=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'polCityCode'"
          no="polCityCode"
          :static-options="citySeaport"
          tag-name="name"
          tag-value="code"
          :placeholder="$t('Pricing.POLCityPrompt')"
          clearable
          filterable
          :filter-tag-names="['name', 'code']"
          style="width:190px;display: inline-block;"
          :default-value="filter.polCityCode"
          @parentCallBack="p=>{filter.polCityCode=p.value}"
        />
        <el-select
          v-model="filter.cmbCreatedBy"
          no="cmbCreatedBy"
          :disabled="isShowCreatedBy"
          style="width:80px;display: inline-block;margin-left: 10px;"
        >
          <el-option :label="$t('Pricing.CreatedBy')" value="createdBy" />
          <el-option :label="$t('Pricing.Branch')" value="branch" />
        </el-select>
        <cargo-advance-select
          v-if="filter.cmbCreatedBy === 'createdBy'"
          no="createdBy"
          filterable
          :select-type="selectTypeNames.basic_data_User"
          :default-value="filter.createdBy"
          :callback-params="{key:'userId'}"
          style="width:282px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.createdBy=p.value}"
        />
        <cargo-office-select
          v-if="filter.cmbCreatedBy === 'branch'"
          no="branch"
          :disabled="false"
          :office-id="!filter.branch ? 0 : filter.branch"
          :default-value="filter.branch"
          :tag-name="'code'"
          style="width:282px;display: inline-block;margin-left: 10px;"
          @change="p=>{filter.branch=p.value}"
        />
        <el-form-item v-if="isManageModule" ref="hbDateCreatedFromTo" :label="$t('Pricing.CreatedDate')">
          <el-date-picker
            v-model="filter.createDateFrom"
            no="createDateFrom"
            type="date"
            style="width:130px;margin-left:10px"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() >
                  new Date(filter.createDateTo + ' 23:59:59').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.createDateTo"
            no="createDateTo"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() <
                  new Date(filter.createDateFrom + ' 00:00:00').getTime()
                )
              }
            }"
            type="date"
            style="width:130px;margin-left:10px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="isShowSaleState" ref="hbSaleState" label-width="80px" :label="$t('Pricing.SaleState')">
          <cargo-advance-select
            no="saleState"
            style="width: 115px;"
            filterable
            :disabled="disabled"
            :clearable="false"
            :default-value="filter.saleState"
            :headers="[$t('Price.Code')]"
            :fields="['code']"
            tag-name="chineseName"
            tag-value="code"
            :select-type="selectTypeNames.local_cache_SpecialPriceSaleState$SALE_STATE_TYPES_All"
            @parentCallBack="p=>{filter.saleState=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="isShowContractNo" ref="hbContractNo" :label="$t('Pricing.ContractNo')">
          <el-input v-model="filter.contractNo" no="contractNo" style="width: 85px;" />
        </el-form-item>
        <el-form-item v-if="isSurcharge" ref="hbDangerous" label-width="80px" :label="$t('Pricing.Dangerous')">
          <el-checkbox v-model="filter.dangerous" no="dangerous" />
        </el-form-item>
        <el-form-item v-if="isSurcharge && !isQuery" ref="hbBookingAgent" :label="$t('Pricing.BookingAgent')">
          <cargo-advance-select
            no="bAgentAutoComplete"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true}"
            :custom-label="(item)=>`${item.chineseName}`"
            :show-custom-label-in-option="true"
            style="width:190px;"
            tag-value="cmpIdx"
            @parentCallBack="p=>{filter.bAgentAutoComplete=p.cmpIdx}"
          />
        </el-form-item>
        <el-form-item v-if="isSurcharge && !isQuery" ref="hFeeName" :label="$t('Pricing.FeeName')">
          <cargo-advance-select
            no="chargeScaleCode"
            filterable
            :select-type="selectTypeNames.basic_data_ChargeItem"
            callback-method-type="value"
            style="width:190px;"
            tag-name="zhName"
            tag-value="scaleCode"
            @parentCallBack="p=>{filter.chargeScaleCode=p}"
          />
        </el-form-item>
        <el-form-item v-if="showCurrency" ref="hbCurrency" label-width="75px" :label="$t('Pricing.Currency')">
          <cargo-advance-select
            no="currency"
            style="width: 115px;"
            filterable
            :disabled="disabled"
            :clearable="false"
            :default-value="filter.currency"
            :select-type="selectTypeNames.basic_data_Currency"
            @parentCallBack="changeCurrency"
          />
        </el-form-item>
      </el-form>
      <el-form ref="hbDetail2" label-width="80px" label-position="left" :inline="true">
        <el-radio-group v-model="rdoGroupDes" no="rdoGroupDes">
          <el-radio no="POD" label="pod">{{ $t('Pricing.POD') }}</el-radio>
          <el-radio no="PODs" label="pods">{{ $t('Pricing.PODs') }}</el-radio>
          <el-radio no="COD" label="cod">{{ $t('Pricing.COD') }}</el-radio>
          <el-radio no="ROD" label="rod">{{ $t('Pricing.ROD') }}</el-radio>
          <el-radio no="PODCity" label="podCityCode">{{ $t('Pricing.PODCity') }}</el-radio>
        </el-radio-group>
        <cargo-advance-select
          v-if="rdoGroupDes === 'pod'"
          no="pod"
          filterable
          :placeholder="$t('Pricing.PODPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          style="width:190px;display: inline-block;"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.pod"
          @parentCallBack="p=>{filter.pod=p.value}"
        />
        <cargo-pop-select-input
          v-if="rdoGroupDes === 'pods'"
          v-model="filter.pods"
          no="pods"
          style="width:190px;display: inline-block;"
          :column-defs="popSelectInputCols"
          :use-type="2"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'cod'"
          no="cod"
          filterable
          :placeholder="$t('Pricing.CODPrompt')"
          :select-type="selectTypeNames.basic_data_Country"
          style="width:190px;display: inline-block;"
          :default-value="filter.cod"
          @parentCallBack="p=>{filter.cod=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'rod'"
          no="rod"
          filterable
          :select-type="selectTypeNames.basic_data_Region"
          style="width:190px;display: inline-block;"
          :default-value="filter.rod"
          @parentCallBack="p=>{filter.rod=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'podCityCode'"
          no="podCityCode"
          :static-options="citySeaport"
          tag-name="name"
          tag-value="code"
          clearable
          :placeholder="$t('Pricing.PODCityPrompt')"
          filterable
          :filter-tag-names="['name', 'code']"
          style="width:190px;display: inline-block;"
          :default-value="filter.podCityCode"
          @parentCallBack="p=>{filter.podCityCode=p.value}"
        />
        <el-form-item ref="hbCarrier" :label="$t('Pricing.Carrier')" style="margin-left: 10px;">
          <cargo-advance-select
            no="carrier"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{seaCmp:true}"
            :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
            :show-custom-label-in-option="true"
            style="width:300px;"
            multiple
            :default-multiple-value="filter.carrier"
            @parentCallBack="p=>{filter.carrier=p.cmpIdx}"
          />
        </el-form-item>
        <el-form-item ref="hbSource" :label="$t('Pricing.Source')">
          <el-input v-model="filter.txtBookingAgent" no="txtBookingAgent" style="width: 100px;" />
        </el-form-item>
        <el-form-item ref="hbFromTo" :label="$t('Pricing.BeginDate')" style="margin-left: 10px;">
          <el-date-picker
            v-model="filter.beginDate"
            no="beginDate"
            type="date"
            style="width:130px;margin-left:10px"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() >
                  new Date(filter.endDate + ' 23:59:59').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.endDate"
            no="endDate"
            type="date"
            style="width:130px;"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() <
                  new Date(filter.beginDate + ' 00:00:00').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="showLevel" ref="hbLevel" :label="$t('Pricing.Level')">
          <el-select
            v-model="filter.level"
            no="level"
            style="width:100px;display: inline-block;"
            @change="onLevelChanged"
          >
            <el-option
              v-for="(item,index) in tiers"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isSurcharge" ref="hbUnNo" :label="$t('Pricing.UnNo')">
          <el-input v-model="filter.unNo" no="unNo" style="width: 85px;" />
        </el-form-item>
        <el-form-item v-show="showExpirationDate" :label="$t('Pricing.ExpirationDate')" style="margin-left: 10px">
          <el-date-picker
            v-model="filter.expirationBeginDate"
            no="expirationBeginDate"
            type="date"
            style="width:130px;margin-left:10px"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() >
                  new Date(filter.expirationEndDate + ' 23:59:59').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.expirationEndDate"
            no="expirationEndDate"
            type="date"
            style="width:130px;"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() <
                  new Date(filter.expirationBeginDate + ' 00:00:00').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item ref="hbCarrier" :label="$t('SeaExport.CargoType')" style="margin-left: 10px;">
          <cargo-advance-select
            no="cargoType"
            :select-type="selectTypeNames.basic_data_CargoType"
            :headers="[$t('Partners.chineseName')]"
            :fields="['chineseName']"
            :filter-field-names="['chineseName']"
            filterable
            :clearable="false"
            :default-value="filter.cargoType"
            @parentCallBack="p=>{filter.cargoType=p.value}"
          />
        </el-form-item>
      </el-form>
      <el-form label-width="80px" label-position="left" :inline="true">
        <el-form-item :label="$t('Pricing.PriceType')">
          <cargo-advance-select
            :disabled="disabledFreightType"
            no="freightType"
            :static-options="priceTypes"
            tag-value="code"
            :default-value="filter.freightType"
            clearable
            @parentCallBack="p=>{filter.freightType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="!showSpotSearch" :label="$t('SeaExport.Vessel')">
          <cargo-advance-select
            no="vessel"
            :select-type="selectTypeNames.static_data_Vessel"
            :cache="false"
            filterable
            :allow-create="true"
            :static-options="vesselList"
            :default-value="filter.vessel"
            @parentCallBack="p=>{onVesselSelectionChange(p)}"
          />
        </el-form-item>
        <el-form-item v-if="!showSpotSearch" :label="$t('SeaExport.Voyage')">
          <cargo-advance-select
            ref="voyageFlight"
            no="6"
            :static-options="voyages || []"
            :cache="false"
            :default-value="filter.voyageFlight"
            filterable
            clearable
            :allow-create="true"
            tag-name="voyageNo"
            tag-value="voyageNo"
            :filter-tag-names="['voyageNo']"
            @parentCallBack="p=>{filter.voyageFlight=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="!showSpotSearch" label="ETD" style="margin-left: 10px;">
          <el-date-picker
            v-model="filter.beginEtd"
            no="beginEtd"
            type="date"
            style="width:130px;margin-left:10px"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() >
                  new Date(filter.endEtd + ' 23:59:59').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.endEtd"
            no="endEtd"
            type="date"
            style="width:130px;"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() <
                  new Date(filter.beginEtd + ' 00:00:00').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="!showSpotSearch" label="ETA" style="margin-left: 10px;">
          <el-date-picker
            v-model="filter.beginEta"
            no="beginEta"
            type="date"
            style="width:130px;margin-left:10px"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() >
                  new Date(filter.endEta + ' 23:59:59').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.endEta"
            no="endEta"
            type="date"
            style="width:130px;"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() <
                  new Date(filter.beginEta + ' 00:00:00').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="showVia" label-width="45px" :label="$t('Pricing.Direct')">
          <cargo-advance-select
            no="directType"
            filterable
            tag-name="chineseName"
            tag-value="code"
            :filter-tag-names="['chineseName', 'code']"
            :static-options="directTypes"
            multiple
            :clearable="false"
            :default-multiple-value="filter.directTypes"
            @parentCallBack="p=>{filter.directTypes=p.code}"
          />
        </el-form-item>
      </el-form>
      <el-form v-if="showSchedule" label-width="80px" label-position="left" :inline="true">
        <el-checkbox v-if="needAddon" v-model="filter.isAddon" no="isAddon">Addon</el-checkbox>
        <el-checkbox v-model="filter.direct" no="direct">{{ $t('Pricing.Direct') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency1" no="frequency1">{{ $t('Pricing.Mon') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency2" no="frequency2">{{ $t('Pricing.Tue') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency3" no="frequency3">{{ $t('Pricing.Wed') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency4" no="frequency4">{{ $t('Pricing.Thu') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency5" no="frequency5">{{ $t('Pricing.Fri') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency6" no="frequency6">{{ $t('Pricing.Sat') }}</el-checkbox>
        <el-checkbox v-model="filter.frequency7" no="frequency7">{{ $t('Pricing.Sun') }}</el-checkbox>
      </el-form>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import StrUtils from '@/utils/StrUtils'
import CargoPopSelectInput from '@/components/Cargo/Common/CargoPopSelectInput/index'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as commonUtil from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import { loadSpecificBasicInfo } from '@/api/cache'
import { Voyage } from '@/class/model/mdm/Voyage'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

export default {
  name: 'FclSearchBar',
  components: {
    CargoPopSelectInput,
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: false }, // 禁用
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    isShowCreatedBy: { type: Boolean, default: false },
    isManageModule: { type: Boolean, default: false },
    isQueryPrice: { type: Boolean, default: false },
    isShowContractNo: { type: Boolean, default: false },
    isShowSaleState: { type: Boolean, default: false },
    showCurrency: { type: Boolean, default: false },
    showPriceNo: { type: Boolean, default: false },
    showSchedule: { type: Boolean, default: true }, // 是否显示船期
    isQuery: { type: Boolean, default: false }, // 是否是查询界面
    showExpirationDate: { type: Boolean, default: false }, // 是否显示失效日期搜索条件
    isSurcharge: { type: Boolean, default: false },
    configId: { type: String, required: false },
    source: { type: String, required: false, default: '' },
    isCp: { type: Boolean, default: true },
    disabledFreightType: { type: Boolean, default: false },
    filter: { type: Object, default: () => {
      return {}
    }
    },
    showVia: { type: Boolean, default: false } // 是否显示中转港
  },
  data() {
    return {
      showLevel: false,
      URL,
      vesselList: [],
      voyages: [],
      selectTypeNames: TYPE_NAMES,
      tiers: [],
      pickerOptions0: { // 设置可选时间范围
        disabledDate: (time) => {
          if (this.filter.createDateTo !== '') {
            return time.getTime() > new Date(this.filter.createDateTo).getTime()
          }
        }
      },
      pickerOptions1: { // 设置可选时间范围
        disabledDate: (time) => {
          if (this.filter.createDateFrom !== '') {
            return time.getTime() > new Date(this.filter.createDateFrom).getTime()
          }
        }
      },
      fclConfigUtil: null,
      rdoGroupOrg: 'pol',
      rdoGroupDes: 'pod',
      rowData: [],
      txtRemarks: '',
      remarkChange: false,
      needAddon: false,
      citySeaport: ColumnUtils.getCitySeaport(),
      simQueryPlaceholder: this.$t('Pricing.priceNoPrompt'), // 快捷检索 占位符
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      proxy: {},
      showDetail: false,
      keyWords: null,
      popSelectInputCols: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Price.Code')
        }, {
          colId: 'chineseName',
          field: 'chineseName',
          headerName: this.$t('Price.ChineseName')
        }, {
          colId: 'englishName',
          field: 'englishName',
          headerName: this.$t('Price.EnglishName')
        }, {
          colId: 'countryCnName',
          field: 'countryCnName',
          headerName: this.$t('Price.Country')
        }, {
          colId: 'region',
          field: 'region',
          headerName: this.$t('Price.Region'),
          valueFormatter: (params) => {
            const { data } = params
            return this.$store.getters.language === 'zh' ? data.regionCnName : data.regionEnName
          }
        }
      ],
      directTypes: PriceConstant.DIRECT_TYPE
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    localConfigId() {
      return this.configId + this.$store.getters.userId
    },
    priceTypes() {
      return this.showSpotSearch ? PriceConstant.PRICE_ALL_TYPES : PriceConstant.PRICE_TYPES
    },
    showSpotSearch() {
      return this.configId === 'SurchargeFCL' || this.configId === 'PriceFCLExtra'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
      // this.toQuery()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const fclConfigUtil = await PricingFCLConfigUtil.getInstance()
      this.fclConfigUtil = fclConfigUtil
      this.needAddon = fclConfigUtil._needAddon
      if (fclConfigUtil._needMarkup) {
        const showLevel = this.$checkPermission(['PFA']) || this.$checkPermission(['PFT'])
        this.showLevel = !this.isCp ? false : showLevel
        this.tiers = PriceUtils.getTiers(fclConfigUtil._needMarkup, showLevel, this.getAuthedLevel())
      } else {
        this.tiers = PriceUtils.getTiers(false, false, 1)
      }
      if (this.source === 'PriceFCLExtra') {
        this.showLevel = false
      }
      this.filter.level = (this.tiers && this.tiers.length > 0) ? this.tiers[0].value : ''
      const proxy = LocalStorageUtils.getConfiguration(this.localConfigId)
      if (proxy) {
        this.isShowingMoreSearchCondition = proxy.isAdvanced
        this.isAdvancedQuery = proxy.isAdvanced
        commonUtil.objCopy(proxy, this.filter)
        // 触发运价等级修改
        this.onLevelChanged()
      }
      this.$nextTick(() => {
        if (!this.showCurrency) {
          this.filter.currency = ''
        }
        this.setPosition()
      })

      this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      if (this.filter.vessel) {
        const currentVessel = this.vesselList.filter(p => p.englishName === this.filter.vessel)[0]
        if (currentVessel) {
          await this.getVoyageByVessel(currentVessel)
        }
      }
    },
    updateLevel(isCp) {
      if (!isCp) {
        this.showLevel = false
        return
      }
      if (this.fclConfigUtil._needMarkup) {
        const showLevel = this.$checkPermission(['PFA']) || this.$checkPermission(['PFT'])
        this.showLevel = showLevel
      }
    },
    setPosition() {
      const { hbDetail, hbDetail2, hbCarrier, hbSource, hbLevel, hbCurrency, hbDangerous, hbSaleState, hbContractNo, hbUnNo } = this.$refs
      if (!this.isQuery) {
        if (this.showLevel) {
          hbDetail2.$el.appendChild(hbLevel.$el)
        }
        return
      }
      hbDetail.$el.appendChild(hbCarrier.$el)
      hbDetail.$el.appendChild(hbSource.$el)
      hbDetail.$el.appendChild(hbUnNo.$el)
      const isFclRealList = this.configId && this.configId.startsWith('FclRealList')
      if (this.isShowContractNo && isFclRealList) {
        hbDetail.$el.appendChild(hbContractNo.$el)
      }
      if (this.showLevel) {
        hbDetail2.$el.appendChild(hbLevel.$el)
      }
      if (this.showCurrency) {
        hbDetail2.$el.appendChild(hbCurrency.$el)
      }
      hbDetail2.$el.appendChild(hbDangerous.$el)
      if (this.isShowSaleState) {
        hbDetail2.$el.appendChild(hbSaleState.$el)
      }
      if (this.isShowContractNo && !isFclRealList) {
        hbDetail2.$el.appendChild(hbContractNo.$el)
      }
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy['level'] = 1
      this.proxy['isAdvanced'] = false
      // CARGO-25487 整箱附加费维护模块的查询功能会查出两条一样的数据
      if (this.configId !== 'SurchargeFCL') {
        this.proxy['tenantId'] = 0
      }
      if (this.showPriceNo) {
        const priceNo = this.filter.priceNo ? this.filter.priceNo.trim() : ''
        if (!priceNo || priceNo.length === 0) {
          this.simQueryPlaceholder = ''
          this.$refs.keyword.focus()
          this.$message.warning(this.$t('Pricing.priceNoPrompt'))
          return
        }
        this.proxy['priceNo'] = priceNo
      } else {
        if (!this.filter.simPol) {
          this.$message.warning(this.$t('Pricing.POLIsNull'))
          this.$refs.simPol.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        if (!this.filter.simPod) {
          this.$message.warning(this.$t('Pricing.PODIsNull'))
          this.$refs.simPod.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        this.proxy['pol'] = this.filter.simPol
        this.proxy['pod'] = this.filter.simPod
        this.proxy['beginDate'] = DateUtils.formatStandardDate(new Date())
      }
      this.saveConfig()
      this.$emit('simSearchItemCallBack', this.proxy)
    },
    saveConfig() {
      const data = deepClone(this.filter)
      delete data['createDateFrom']
      delete data['createDateTo']
      delete data['beginDate']
      delete data['endDate']
      data['isAdvanced'] = this.isAdvancedQuery
      LocalStorageUtils.setConfiguration(this.localConfigId, data)
    },
    async toAdvancedQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy['isAdvanced'] = true
      this.proxy[this.rdoGroupOrg] = PriceUtils.getSearchPorts(this.filter, this.rdoGroupOrg, 'pols')
      this.proxy[this.rdoGroupDes] = PriceUtils.getSearchPorts(this.filter, this.rdoGroupDes, 'pods')
      const pols = await PriceUtils.getPortGroup(this.proxy.pol)
      if (pols && pols.length > 0) {
        this.proxy.pols = pols
        this.proxy.pol = ''
      }
      const pods = await PriceUtils.getPortGroup(this.proxy.pod)
      if (pods && pods.length > 0) {
        this.proxy.pods = pods
        this.proxy.pod = ''
      }
      this.setDateValue('createDateFrom', false)
      this.setDateValue('createDateTo', true)
      this.setDateValue('beginDate', false)
      this.setDateValue('endDate', true)
      if (this.showExpirationDate) {
        this.setDateValue('expirationBeginDate', false)
        this.setDateValue('expirationEndDate', true)
      }
      if (this.showSchedule) {
        const FREQUENCYS = PriceUtils.FREQUENCYS
        const frequency = []
        for (const field of FREQUENCYS) {
          if (this.filter['frequency' + field]) {
            frequency.push('frequency' + field)
          }
        }
        frequency.join('/')
        this.proxy['frequencys'] = frequency
      }
      if (this.isManageModule || this.isShowCreatedBy) {
        if (this.filter.cmbCreatedBy === 'createdBy') {
          this.proxy['createdBy'] = this.filter.createdBy
        }
        if (this.filter.cmbCreatedBy === 'branch') {
          this.proxy['branchId'] = this.filter.branch
        }
      }
      // 是否过滤中转港
      if (this.showVia) {
        this.proxy['directTypes'] = this.filter.directTypes.join(',')
      }
      if (this.filter.carrier.length > 0) {
        const scacs = this.getCompanyByScac(this.filter.carrier)
        if (scacs.length === 0 || !this.isQueryPrice) {
          this.proxy['carriers'] = this.filter.carrier.join(',')
        } else {
          this.proxy['carrierScac'] = scacs
        }
      }
      this.setBooleanValue('direct')
      this.setBooleanValue('isAddon')
      this.setBooleanValue('dangerous')
      this.setStrValue('unNo')
      this.setStrValue('txtBookingAgent')
      this.setStrValue('cargoType')
      if (this.filter.saleState >= 0 && this.isShowSaleState) {
        this.proxy['saleState'] = this.filter.saleState
      }
      if (this.isShowContractNo && !StrUtils.isEmpty(this.filter.contractNo)) {
        this.proxy['contractNo'] = this.filter.contractNo
      }
      this.setIntValue('bAgentAutoComplete')
      this.setStrValue('chargeScaleCode')

      this.setDateValue('beginEtd', false)
      this.setDateValue('endEtd', true)
      this.setDateValue('beginEta', false)
      this.setDateValue('endEta', true)
      if (typeof this.filter.freightType === 'number') {
        this.proxy['freightType'] = this.filter.freightType
      }
      this.setStrValue('vessel')
      this.setStrValue('voyageFlight')

      this.saveConfig()
      this.$emit('advSearchItemResetCallBack', this.proxy)
    },
    setStrValue(field) {
      if (!StrUtils.isEmpty(this.filter[field])) {
        this.proxy[field] = this.filter[field]
      }
    },
    setDateValue(field, isEnd) {
      if (!StrUtils.isEmpty(this.filter[field])) {
        this.proxy[field] = this.filter[field] + (isEnd ? ' 23:59:59' : '')
      }
    },
    setIntValue(field) {
      if (this.filter[field] > 0) {
        this.proxy[field] = this.filter[field]
      }
    },
    setBooleanValue(field) {
      if (this.proxy.hasOwnProperty(field)) {
        delete this.proxy[field]
      }
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PFDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PFDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PFDA_*_2'])) {
        return 2
      }
      return 99
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    resetSearch() {
      const level = this.filter.level
      const currency = this.filter.currency
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.cmbCreatedBy = 'createdBy'
      this.filter.currency = currency
      this.filter.level = level
      this.filter.saleState = -1
      this.filter.freightType = null
      this.filter.isDirect = true
      this.filter.isVia = true
      this.$emit('reset')
    },
    onLevelChanged() {
      const { showLevel } = this
      this.$emit('onLevelChanged', { showLevel, level: this.filter.level })
      this.$emit('onGridRefresh')
    },
    getCompanyByScac(value) {
      const companyStr = []
      for (const cmpIdx of value) {
        const scac = ColumnUtils.companyLabelFun(cmpIdx, 'scac', 'cmpIdx')
        if (!StrUtils.isEmpty(scac)) {
          companyStr.push(scac)
        }
      }
      return companyStr
    },
    changeCurrency(p) {
      this.filter.currency = p.value
      this.$emit('onGridRefresh')
    },
    /**
     * vessel change
     */
    onVesselSelectionChange(data) {
      this.filter.vessel = data.value
      this.getVoyageByVessel(data)
    },
    async getVoyageByVessel(data) {
      if (data.vesselId) {
        this.voyages = await Voyage.getVoyage(data.vesselId)
      } else {
        this.voyages = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.fcl-search-bar{
  .el-radio-group{
    /deep/ .el-radio{
      margin-right: 15px;
    }
  }

}

</style>

